// extracted by mini-css-extract-plugin
export default {"ButtonLink":"TodoItemGAS_ButtonLink__mmHmS","Checkbox":"TodoItemGAS_Checkbox__xCxd5","Dim":"TodoItemGAS_Dim__28L+R","List":"TodoItemGAS_List__mobCZ"};